import { APINames } from 'src/shared';
import { GeneralInvokeOption, IAnyStrObject } from 'src/types';
import MacleJSBridge from 'src/bridges';

export interface PostMessageOption extends Partial<GeneralInvokeOption> {
  data: string | IAnyStrObject;
}

/**
 * 向小程序发送消息，会在特定时机（小程序后退、组件销毁）触发组件的 message 事件
 * 需要通过 bindmessage 接收
 *
 * ```js
 *   ma.miniProgram.postMessage({
 *     data: 'foo' | { foo: 'bar' },
 *     success: function(res) {},
 *     fail: function(res) {},
 *     complete: function(res) {},
 *   })
 * ```
 */
export function postMessage(option: PostMessageOption) {
  MacleJSBridge.beforeInvoke(APINames.MiniProgram.POST_MESSAGE, option);
}
